import React from "react";
import "./Services.css";
import { NavLink } from "react-router-dom";

const ServicesPage = () => (
  <div className="services-page">
    <header className="page-hero">
      <h1>Services Overview</h1>
      <p>
        Explore our smart storage, dispensing, and rental solutions for any
        environment.
      </p>
    </header>

    <ServiceCategory
      title="Storage Services"
      grey
      intro="Qeeper's Storage Services are designed to provide maximum flexibility and ease of use in any environment where secure storage is essential. With a powerful locker management system at its core, Qeeper allows organizations to choose from a variety of assignment options tailored to different user scenarios—whether for permanent staff, temporary guests, or shared team access."
      subServices={[
        {
          title: "Static Locker Assignment",
          description:
            "Ideal for permanent users such as employees or students who need long-term access to a dedicated locker.",
        },
        {
          title: "Dynamic Locker Assignment",
          description:
            "Enables flexible, temporary use of lockers, allowing users to claim and release lockers independently.",
        },
        {
          title: "Guest Lockers",
          description:
            "User-friendly and accessible lockers for visitors, with access options via smartphone, QR code, or PIN—no administrator needed.",
        },
        {
          title: "Team Lockers",
          description:
            "Lockers shared among multiple users or departments, perfect for collaborative environments or shared resource access.",
        },
      ]}
    />

    <ServiceCategory
      title="Dispensing Solutions"
      intro="Qeeper's Dispensing Solutions are developed to streamline the distribution, lending, and return of physical items in a secure and automated way. These services eliminate the need for manual handovers or staffed service desks, enabling 24/7 availability for users to collect, return, or exchange goods—on their own terms and schedule."
      subServices={[
        {
          title: "IT Equipment Dispensing",
          description:
            "Automated distribution and return of devices such as laptops, phones, or peripherals—ideal for IT service desks in hybrid workplaces.",
        },
        {
          title: "Tool and Asset Lending",
          description:
            "Secure lending and return of valuable company assets like tools, uniforms, or keys, with full usage tracking and control.",
        },
        {
          title: "Pick-Up and Drop-Off",
          description:
            "Locker-based item exchange for internal logistics, allowing users to collect or return goods without appointments or direct contact.",
        },
        {
          title: "Click & Collect",
          description:
            "A consumer-friendly solution for retailers that allows customers to collect online orders at any time, even outside store hours.",
        },
      ]}
    />

    <ServiceCategory
      title="Rental Solutions"
      grey
      intro="Qeeper's Rental Solutions provide a seamless, self-service experience for renting lockers or products without the need for staff intervention. Whether offering temporary locker use at an event, product rental in public spaces, or automated product vending, Qeeper empowers users to access what they need—when they need it."
      subServices={[
        {
          title: "Locker Rental",
          description:
            "Secure, autonomous locker use for temporary storage, perfect for cloakroom replacement at events, theatres, or leisure venues.",
        },
        {
          title: "Product Rental",
          description:
            "Contactless rental of company or consumer items such as tools, audio guides, or uniforms—easily returned via the same locker interface.",
        },
        {
          title: "Product Vending",
          description:
            "Fully automated dispensing of purchasable goods, enabling 24/7 access to essential or promotional items without the need for a staffed counter.",
        },
      ]}
    />

    <section className="page-cta">
      <h2>Learn More About Our Services</h2>
      <p>
        Contact us to see how Qeeper can optimize your storage, dispensing, and
        rental operations.
      </p>
      <NavLink to="/contact" className="page-cta__button">
        Contact us
      </NavLink>
    </section>
  </div>
);

const ServiceCategory = ({ title, intro, subServices, grey }) => (
  <section className={`service-section${grey ? " service-section--grey" : ""}`}>
    <div className="service-section__inner">
      <h2>{title}</h2>
      <p className="service-section__intro">{intro}</p>

      <div className="service-section__grid">
        {subServices.map((s, i) => (
          <div key={i} className="service-card">
            <h3>{s.title}</h3>
            <p>{s.description}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default ServicesPage;
